import { AxiosInstance } from "axios"
import { CompaniesAdminsItem } from "./adminsTypes"

export enum CompanyAdminsQuery {
    ADMINS_FOR_COMPANY = "admins-for-company",
}

export type CompaniesAdminsParams = Readonly<{
    companyId: number
}>

export type CompaniesAdminsResponse = Readonly<{
    administrators: CompaniesAdminsItem[]
}>

export async function fetchCompaniesAdmins(
    { companyId }: CompaniesAdminsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CompaniesAdminsResponse> {
    const url = `/companies/${companyId}/administrators`
    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
